import { createContext, type ReactNode, useContext, useState } from "react";

interface CommentsContextType {
  commentsOpen: boolean;
  setCommentsOpen: (open: boolean) => void;
}

const CommentsContext = createContext<CommentsContextType | undefined>(undefined);

export const useCommentsContext = () => {
  const context = useContext(CommentsContext);
  if (!context) {
    throw new Error("useCommentsContext must be used within a CommentsProvider");
  }
  return context;
};

export const CommentsProvider = ({ children }: { children: ReactNode }) => {
  const [commentsOpen, setCommentsOpen] = useState(false);

  return (
    <CommentsContext.Provider value={{ commentsOpen, setCommentsOpen }}>
      {children}
    </CommentsContext.Provider>
  );
};
